import { playNotificationAudioSilent } from '@/utils/audio-utils/play-notification-audio.ts';

export const checkUserInteractionWithAudio = async (onError: () => void) => {
  try {
    await playNotificationAudioSilent();
  } catch (error) {
    /**
     * "NotAllowedError" occurs when the user need to interact with the document before the audio can be played.
     * https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play#exceptions
     */
    if ((error as Error).name === 'NotAllowedError') {
      onError();
    }
  }
};
